import { type ChangeEvent, useRef } from "react";
import React from "react";
import { cn, Label } from "../ui";

export function CustomFileInput({
  value,
  placeholder,
  onChange,
  className,
  accept,
  acceptDrop = false,
}: {
  value: string;
  placeholder?: string;
  className?: string;
  onChange: (val: File) => void;
  accept?: string;
  acceptDrop?: boolean;
}) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageUploadClick = () => {
    fileInputRef.current?.click();
  };

  const updateImage = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      onChange(file);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (acceptDrop && event.dataTransfer.files && event.dataTransfer.files[0]) {
      const file = event.dataTransfer.files[0];
      onChange(file);
    }
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDrop={handleFileDrop}
      onClick={handleImageUploadClick}
    >
      <Label className={cn("hover:cursor-pointer", className)}>
        {value ? value : placeholder}
      </Label>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        style={{ display: "none" }}
        onChange={updateImage}
      />
    </div>
  );
}
